import $ from 'jquery';
import '../vendor/slick-carousel/slick.fix';
import '../vendor/dotimeout/jquery.ba-dotimeout.min';

const limit = 1000;
let current = 0;

const defaults = {
  speed: 200,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  slide: '.tweet',
  rows: 3,
};

function TweetSlider(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.verifySlides();
}

TweetSlider.prototype = {
  init() {
    // add slick carousel functionality
    this.addSlick();
    // set component ready
    this.ready();
  },
  // Needing to loop the slide query due to them not being ready every time
  verifySlides() {
    const that = this;
    const $slides = this.$element.find(this.settings.slide);

    if (!$slides.length) {
      current += 1;

      if (current <= limit) {
        // set a timeout to repeat the verifySlides function again
        this.$element.doTimeout('wait', 100, () => {
          that.verifySlides();
        });
      }
    } else {
      // cancel timeout
      this.$element.doTimeout('wait');
      this.init();
    }
  },
  addSlick() {
    this.$element.find('.dd-twitter-feed-tweets').slick(this.settings);
  },
  ready() {
    this.$element.find('.dd-twitter-feed').addClass('ready');
  },
};

export default TweetSlider;



// WEBPACK FOOTER //
// ./TwitterSlider.js